import Vue from 'vue'

import './config-check'
import './console-splash'

import './google-maps'

import './plugins'
import './mixins'
import './components'

import i18n, { options as i18nOptions } from './i18n'
import store from './store'
import router from './router'

export default (options = {}) => {
  options = {
    el: '#app',
    name: 'one',
    template: '<router-view />',

    router,
    store,
    i18n: i18n(options.i18nOptions || i18nOptions),

    // Any additional options we want to merge
    ...options,
  }

  return new Vue(options)
}
